import { DocumentMeta, Permissions } from "@cnx/common";
import api from "services/api";

class DocumentService {
  static getAllDocumentsMetaByContextId = async ({
    contextId,
    viewPermissions,
  }: {
    contextId: string;
    viewPermissions?: Permissions[];
  }): Promise<DocumentMeta[]> => {
    const { data } = await api.get<DocumentMeta[]>(
      `/documents-meta/${contextId}`,
      {
        params: { viewPermissions: viewPermissions?.join(",") },
      }
    );
    return data;
  };

  static removeDocumentsByIds = async (
    documentIds: string[]
  ): Promise<void> => {
    await api.delete("/documents", {
      data: { documentIds },
    });
  };

  static getDocumentAsBuffer = async (
    pathToFile: string,
    contentType?: string
  ): Promise<Blob> => {
    const { data } = await api.get<Blob>("/document", {
      params: { pathToFile, contentType },
      responseType: "blob",
    });

    return data;
  };
}

export default DocumentService;
